import { render, staticRenderFns } from "./aRoomDetailCarFee.vue?vue&type=template&id=5407b7f4&scoped=true"
import script from "./aRoomDetailCarFee.vue?vue&type=script&lang=js"
export * from "./aRoomDetailCarFee.vue?vue&type=script&lang=js"
import style0 from "./aRoomDetailCarFee.vue?vue&type=style&index=0&id=5407b7f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5407b7f4",
  null
  
)

export default component.exports